import { TUserSendEmailData, TUserSendEmailPeerSupportOrMemberCare } from '@/types/User.types';
import { api, TCustomAxiosResponse } from '..';

const rootPath = '/v1/contact';

const endpoints = {
  contact: rootPath,
};

export const sendEmail = async (
  peerSupportOrMemberCare: TUserSendEmailPeerSupportOrMemberCare,
  userSendEmailData: TUserSendEmailData,
): Promise<{ success: boolean }> => {
  const { data } = await api.post(`${endpoints.contact}/${peerSupportOrMemberCare}`, userSendEmailData);
  return data.data;
};

export const contractSalesPost = async (contractId: string, subject: string, message: string) => {
  const { data } = await api.post<TCustomAxiosResponse<unknown>>(`${endpoints.contact}/contract-sales`, {
    contractId,
    subject,
    message,
  });

  return data.data;
};
